import React from "react";
import { Dropdown, DropdownButton, Row } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import { faCogs } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import InstanceStatus from "../../../../../helpers/InstanceStatus";
import StorageService from "../../../../../services/StorageService";

class ExamInstanceActionCell extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      user: null,
      templateConfiguration: null
    };

    this.showStart = this.showStart.bind(this);
    this.showStop = this.showStop.bind(this);
    this.showSubmission = this.showSubmission.bind(this);
    this.showExamFileDownloadReset = this.showExamFileDownloadReset.bind(this);
    this.isDropdownDisabled = this.isDropdownDisabled.bind(this);
    this.showStudentExamFileUpload = this.showStudentExamFileUpload.bind(this);
    this.showDeviceAssignment = this.showDeviceAssignment.bind(this);
    this.showOneTimeStudentPassword = this.showOneTimeStudentPassword.bind(this);
    this.showAdminToken = this.showAdminToken.bind(this);
    this.showPaperNotes = this.showPaperNotes.bind(this);
    this.showDeviceReset = this.showDeviceReset.bind(this);
  }

  componentDidMount() {
    let templateConfiguration = null;
    try {
      templateConfiguration = JSON.parse(atob(this.props.instanceTemplate.configuration))
    }catch (err){}

    this.setState({
      user: StorageService.getUser(),
      templateConfiguration
    });
  }

  showAdminToken(){
    return this.state.user
        && (this.props.examination.securityLevel >= 1 && this.props.examination.securityLevel <= 4)
        && this.state.user.role === 1;
  }

  showSEBSessionQuit(){
    return this.props.examinationStatus === 11
        && (this.props.examination.securityLevel === 5 || this.props.examination.securityLevel === 6);
  }

  showPaperNotes(){
    return this.props.onHasNotes();
  }

  showDeviceReset(){
    return this.state.user
        && (this.props.examination.securityLevel === 3 || this.props.examination.securityLevel === 4)
        && this.state.user.role === 1;
  }

  showDeviceAssignment(){
    return (this.props.examination.securityLevel === 3 || this.props.examination.securityLevel === 4)
        && (
            this.props.examinationStatus === 1
            || (this.props.examinationStatus >= 10 && this.props.examinationStatus <= 13)
            || (this.props.examinationStatus >= 30 && this.props.examinationStatus <= 32)
            || (this.props.examinationStatus >= 50 && this.props.examinationStatus <= 53)
        );
  }

  showStudentExamFileUpload() {
    return (this.props.instanceTemplate.type === 0 || this.props.instanceTemplate.type === 2
            || (
                this.props.instanceTemplate.type === 1
                && this.state.templateConfiguration
                && typeof this.state.templateConfiguration["static"] !== "undefined"
                && typeof this.state.templateConfiguration["static"]["enable_smb_share"] !== "undefined"
                && this.state.templateConfiguration.static.enable_smb_share))
        && (
            this.props.examinationStatus === 1
            || this.props.examinationStatus === 11
            || (this.props.examinationStatus >= 50 && this.props.examinationStatus <= 53));
  }

  showOneTimeStudentPassword(){
    return (this.props.examinationStatus === 1
        || this.props.examinationStatus === 11
        || (this.props.examinationStatus >= 50 && this.props.examinationStatus <= 53))
        && this.props.instanceTemplate.hasInternalLogin
  }

  showStart() {
    return (
      InstanceStatus.showStart(this.props.instance.status) &&
      (this.props.examinationStatus === 11 ||
        this.props.examinationStatus === 31)
    );
  }

  showBackup() {
    return this.state.user
        && this.state.user.role === 1
        && this.props.examinationStatus === 61;
  }

  showStop() {
    return (
      InstanceStatus.showStop(this.props.instance.status) &&
      (this.props.examinationStatus === 11 ||
        this.props.examinationStatus === 31)
    );
  }

  showSubmission() {
    return (
      (this.props.examinationStatus === 21 ||
        this.props.examinationStatus === 60 ||
        this.props.examinationStatus === 61) &&
      this.props.instance.status !== 11
    );
  }

  showExamFileDownloadReset() {
    return (
      this.props.examinationStatus === 11 || this.props.examinationStatus === 31
    );
  }

  hasNothingToShow(){
    return !(this.showStart()
    || this.showStop()
    || this.showStudentExamFileUpload()
    || this.showSubmission()
    || this.showBackup()
    || this.showPaperNotes()
    || this.showExamFileDownloadReset()
    || this.showDeviceAssignment()
    || this.showDeviceReset()
    || this.showOneTimeStudentPassword()
    || this.showAdminToken()
    || this.showSEBSessionQuit());
  }

  isDropdownDisabled() {
    return (
      !(
        this.props.examinationStatus === 11 ||
        this.props.examinationStatus === 21 ||
        this.props.examinationStatus === 30 ||
        this.props.examinationStatus === 32 ||
        this.showStudentExamFileUpload() ||
        this.showDeviceAssignment() ||
        this.showOneTimeStudentPassword() ||
        this.props.examinationStatus === 60 ||
        this.props.examinationStatus === 61
      )
      || this.hasNothingToShow()
      || (
          (this.props.examinationStatus === 11 || this.props.examinationStatus === 31) &&
          !InstanceStatus.showStart(this.props.instance.status) &&
          !InstanceStatus.showStop(this.props.instance.status) &&
        this.props.instance.status !== 11
      )
    );
  }

  render() {
    const { t } = this.props;
    return (
      <Row style={{ marginRight: "-12px", float: "right" }}>
        <div style={{}}>
          <DropdownButton
            size="sm"
            disabled={this.isDropdownDisabled()}
            onClick={event => event.stopPropagation()}
            id="dropdown-basic-button"
            title={<FontAwesomeIcon icon={faCogs} />}
            className="btn-green"
          >
            {this.showExamFileDownloadReset() && (
                <Dropdown.Item onClick={this.props.onExamFileDownloadReset}>
                  {t(
                      "SingleExamination.InstanceTab.ActionCell.ExamFileDownloadResetOption"
                  )}
                </Dropdown.Item>
            )}
            {this.showStudentExamFileUpload() && (
                <Dropdown.Item onClick={this.props.onStudentExamFileUpload}>
                  {t("SingleExamination.InstanceTab.ActionCell.StudentExamFileUploadOption")}
                </Dropdown.Item>
            )}
            {this.showSubmission() && (
              <Dropdown.Item onClick={this.props.onDownloadSubmission}>
                {t("SingleExamination.InstanceTab.ActionCell.SubmissionOption")}
              </Dropdown.Item>
            )}
            {this.showBackup() && (
                <Dropdown.Item onClick={this.props.onDownloadBackup}>
                  {t("SingleExamination.InstanceTab.ActionCell.BackupOption")}
                </Dropdown.Item>
              )}
            {this.showPaperNotes() && (
              <Dropdown.Item onClick={this.props.onDownloadPaperNotes}>
                {t("SingleExamination.InstanceTab.ActionCell.PaperNotesOption")}
              </Dropdown.Item>
            )}
            {this.showDeviceAssignment() && (
                <Dropdown.Item onClick={this.props.onDeviceAssignment}>
                  {t(
                      "SingleExamination.InstanceTab.ActionCell.DeviceAssignmentOption"
                  )}
                </Dropdown.Item>
            )}
            {this.showDeviceReset() && (
                <Dropdown.Item onClick={this.props.onDeviceReset}>
                  {t("SingleExamination.InstanceTab.ActionCell.DeviceResetOption")}
                </Dropdown.Item>
            )}
            {this.showOneTimeStudentPassword() && (
                <Dropdown.Item onClick={this.props.onGenerateOneTimeStudentPassword}>
                  {t("SingleExamination.InstanceTab.ActionCell.StudentPasswordOption")}
                </Dropdown.Item>
            )}
            {this.showStart() && (
                <>
                  <Dropdown.Header>{t("SingleExamination.InstanceTab.ActionCell.OptionHeaderComputer")}</Dropdown.Header>
                  <Dropdown.Item onClick={this.props.onStart}>
                    {t("SingleExamination.InstanceTab.ActionCell.StartOption")}
                  </Dropdown.Item>
                </>
            )}
            {this.showStop() && (
                <>
                  <Dropdown.Header>{t("SingleExamination.InstanceTab.ActionCell.OptionHeaderComputer")}</Dropdown.Header>
                  <Dropdown.Item onClick={this.props.onStop}>
                    {t("SingleExamination.InstanceTab.ActionCell.StopOption")}
                  </Dropdown.Item>
                </>
            )}
            {this.showAdminToken() && (
                <>
                  <Dropdown.Header>{t("SingleExamination.InstanceTab.ActionCell.OptionHeaderLernstick")}</Dropdown.Header>
                  <Dropdown.Item onClick={this.props.onGenerateOneTimeToken}>
                    {t("SingleExamination.InstanceTab.ActionCell.AdminTokenOption")}
                  </Dropdown.Item>
                </>
            )}
            {this.showSEBSessionQuit() && (
                <>
                  <Dropdown.Header>{t("SingleExamination.InstanceTab.ActionCell.OptionHeaderSEB")}</Dropdown.Header>
                  <Dropdown.Item onClick={this.props.onSEBSessionQuit}>
                    {t("SingleExamination.InstanceTab.ActionCell.SEBSessionQuitOption")}
                  </Dropdown.Item>
                </>
            )}
          </DropdownButton>
        </div>
      </Row>
    );
  }
}

export default withTranslation()(ExamInstanceActionCell);
